import { Validators } from '../../../../../../utils/validators';
import { FormModel } from '../../../../../../components/Form';

export const ParentOrgGeneralAttributesForm = (strings: any, dropdownValue: any): FormModel[] => {
  return [
    {
      label: strings.organization_text_name,
      value: '',
      type: 'text',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      required: true,
      responsive: { xs: 12 },
    },
    {
      label: strings.show24HourClock,
      value: false,
      type: 'checkbox',
      field: 'show24HourClock',
      responsive: { xs: 12 },
      placeholder: '',
      validators: [],
      required: false,
    },
    {
      label: strings.parentOrg_text_segment,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.parentOrg_text_segment,
      field: 'eventTypes',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      isMulti: true,
      options: dropdownValue.eventTypes,
    },
    {
      label: strings.parentOrg_text_venueType,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.parentOrg_text_venueType,
      field: 'venueTypes',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      isMulti: true,
      options: dropdownValue.venueTypes,
    },
    {
      label: strings.parentOrg_text_location,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.parentOrg_text_location,
      field: 'locations',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      isMulti: true,
      options: dropdownValue.locations,
    },
    {
      label: strings.parentOrg_text_layout,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.parentOrg_text_layout,
      field: 'layouts',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      isMulti: true,
      options: dropdownValue.layouts,
    },
  ];
};
